import { useContext, useState, useEffect } from 'react';
import styles from './UpdateProfile.module.css';
import { Button, Col, Form, Modal } from "react-bootstrap";
import 'react-phone-number-input/style.css';
import PhoneInput, {isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
import VideoContext from '../../store/video-context';
import { toast } from 'react-toastify';
import { countries } from '../../store/country-list';
import { state_list } from '../../store/state-list';
import { user_type } from '../../store/usertype-list';
import { MdAddCircleOutline } from 'react-icons/md';

const UpdateProfile = (props: any) => {
  const vContext = useContext(VideoContext);
  const [validated, setValidated] = useState(false);
  const [invalidPhone, setInvalidPhone] = useState(false);
  const [show, setShow] = useState(true);
  const [userTitle, setUserTitle] = useState(vContext.userData.user_title);
  const [firstName, setFirstName] = useState(vContext.userData.user_first_name);
  const [lastName, setLastName] = useState(vContext.userData.user_last_name);
  const [userTypeId, setUserTypeId] = useState(vContext.userData.user_type_id);
  const [userType, setUserType] = useState(vContext.userData.user_type);
  const [email, setEmail] = useState(vContext.userData.user_email);
  const [phoneNo, setPhoneNo] = useState(vContext.userData.user_phone_no.trim() === "" || vContext.userData.country_code === "" ? "" : "+" + vContext.userData.country_code + vContext.userData.user_phone_no); // may be value useState replace this
  // const [phoneNo, setPhoneNo] = useState("+" + vContext.userData.country_code + vContext.userData.user_phone_no ); // may be value useState replace this
  // const [phoneNo, setPhoneNo] = useState(vContext.userData.user_phone_no); // may be value useState replace this
  const [city, setCity] = useState(vContext.userData.user_city);
  const [user_hospital_name, setHospital] = useState(vContext.userData.user_hospital_name);
  const [state, setState] = useState(vContext.userData.user_state);
  const [country, setCountry] = useState(vContext.userData.user_country);
  const [interest, setInterest] = useState(vContext.userData.user_interest);
  const [qualification, setQualification] = useState(vContext.userData.user_qualification);
  const [specialisation, setSpecialisation] = useState(vContext.userData.user_specialisation);
  const [mci, setMCI] = useState(vContext.userData.user_mci_no);
  const [fields, setFields] = useState({user_email: false,user_phone_no: false, user_country: false,user_title: false, user_first_name: false,user_last_name: false,user_type_id: false,user_type: false,hospital: false,company: false,user_city: false,user_hospital_name: false,
    user_state: false,user_state_list: false,user_interest: false,user_qualification: false,user_specialisation: false,mci: false});
  
   
  const updateProfileApiCall = () =>{
       // console.log('parse number', parsePhoneNumber(phoneNo));
       let data:{ [index: string]: any } = { command:'updateProfile'};
       if(userTitle !== '' && fields.user_title){data.userTitle = userTitle}
       if(firstName !== '' && fields.user_first_name){data.firstName = firstName}
       if(lastName !== '' && fields.user_last_name){data.lastName = lastName}
       if(email !== '' && fields.user_email){data.email = email}
       if(phoneNo !== '' && fields.user_phone_no){
         let parseNumber = parsePhoneNumber(phoneNo); 
         data.mobile = parseNumber!.nationalNumber 
         data.country_code = parseNumber!.countryCallingCode;
         // data.country_code = parsePhoneNumber(phoneNo)?.number
       }
       if(userTypeId !== '' && fields.user_type_id){data.userTypeId = userTypeId}
       if(userType !== '' && (fields.user_type || fields.hospital || fields.company)){data.userType = userType}
       if(city !== '' && fields.user_city){data.city = city}
       if(user_hospital_name !== '' && (fields.user_hospital_name || fields.hospital || fields.company)){data.user_hospital_name = user_hospital_name}
       if(state !== '' && fields.user_state){data.state = state}
       if(state !== '' && fields.user_state_list){data.state = state}
       if(country !== '' && fields.user_country){data.country = country}
       if(interest !== '' && fields.user_interest){data.interest = interest}
       if(qualification !== '' && fields.user_qualification){data.qualification = qualification}
       if(specialisation !== '' && fields.user_specialisation){data.specialisation = specialisation}
       if(mci !== '' && fields.mci){data.mci = mci}
       if(vContext.userId !== ''){data.userID = vContext.userId}
       // console.log('submit', data);
       //alert(userTypeId)
       if(userTypeId == 5 || userTypeId ==6 || userTypeId ==8)
       data.mci="-";

       fetch('https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php', {
       method: 'POST',
       headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
       },
       body: JSON.stringify(data) //JSON.stringify({a: 1, b: 'Textual content'})
     })
       .then(res=>res.json())
       .then((updateProfileData)=>{
         // console.log('updateProfileData',updateProfileData);
         if(updateProfileData.status === "success"){
           toast.dark("Profile Updated Successfully!", {
             position: "top-center",
             autoClose: 5000,
             hideProgressBar: true,
             closeOnClick: true,
             pauseOnHover: true,
             draggable: true,
             progress: undefined,
             });
             setShow(false);
             props.setUpdateProfile()
         }else{
           // console.log("Fail update profile")
           toast.dark("Update Profile Failed!", {
             position: "top-center",
             autoClose: 5000,
             hideProgressBar: true,
             closeOnClick: true,
             pauseOnHover: true,
             draggable: true,
             progress: undefined,
             });
         }
       })
       .catch((error)=>{
         console.error('Error:(handleSubmit)', error);
       })
  }
    
  const handleSubmit = (event: any) => {
    let parseNumber = parsePhoneNumber(phoneNo);
    const form = event.currentTarget;
      event.preventDefault();
      event.stopPropagation();
    // console.log('handleSubmit', event.currentTarget);
    if (form.checkValidity() === false) {
    }
    else{
      // console.log(isValidPhoneNumber(9845698564));
      // debugger;
      if(fields.user_phone_no){
        if(parseNumber && parseNumber!.countryCallingCode == '91'){
          if(parseNumber!.nationalNumber.length != 10){
          setInvalidPhone(true);
          }else{
          updateProfileApiCall();
          }
        }else if(parseNumber && parseNumber!.nationalNumber.length < 5){
          setInvalidPhone(true);          
          }else{
          updateProfileApiCall();
        }
      }else{
        updateProfileApiCall();
      }
    }
    setValidated(true);
  };
  const checkIsValid = (e:any)=>{
    if(e !== undefined || e !== null) {
      // if(validated && isValidPhoneNumber(e) === false){
      //   setInvalidPhone(true);
      // }else{
      //   setInvalidPhone(false);
      // }
    }
  }

  useEffect(()=>{
    let fieldsList = [];
    if(vContext.userData.user_email === "" || vContext.userData.user_email === undefined || vContext.userData.user_email === null){
      fieldsList.push('user_email')
    }
    if(vContext.userData.user_phone_no === "" || vContext.userData.user_phone_no === undefined || vContext.userData.user_phone_no === null 
    || vContext.userData.country_code === "" || vContext.userData.country_code === undefined || vContext.userData.country_code === null){
      fieldsList.push('user_phone_no')
    }
    if(vContext.userData.user_country === "" || vContext.userData.user_country === undefined || vContext.userData.user_country === null){
      fieldsList.push('user_country')
    }
    if(vContext.userData.user_title === "" || vContext.userData.user_title === undefined || vContext.userData.user_title === null){
      fieldsList.push('user_title')
    }
    if(vContext.userData.user_first_name === "" || vContext.userData.user_first_name === undefined || vContext.userData.user_first_name === null){
      fieldsList.push('user_first_name')
    }
    if(vContext.userData.user_last_name === "" || vContext.userData.user_last_name === undefined || vContext.userData.user_last_name === null){
      fieldsList.push('user_last_name')
    }
    if(vContext.userData.user_type_id === "1" || vContext.userData.user_type_id === undefined || vContext.userData.user_type_id === null){
      fieldsList.push('user_type_id')
    }
    if(vContext.userData.user_city === "" || vContext.userData.user_city === undefined || vContext.userData.user_city === null){
      fieldsList.push('user_city')
    }
    if(vContext.userData.user_hospital_name === "" || vContext.userData.user_hospital_name === undefined || vContext.userData.user_hospital_name === null){
      fieldsList.push('user_hospital_name')
    }
    if(vContext.userData.user_state === "" || vContext.userData.user_state === undefined || vContext.userData.user_state === null){
      fieldsList.push('user_state')
    }
   /* if(vContext.userData.user_country === "India" && (vContext.userData.user_state === "" || vContext.userData.user_state === undefined || vContext.userData.user_state === null))
    {
      fieldsList.push('user_state_list')
    }
    else if(vContext.userData.user_state === "" || vContext.userData.user_state === undefined || vContext.userData.user_state === null){
      fieldsList.push('user_state')
    }*/
    if(vContext.userData.user_interest === "" || vContext.userData.user_interest === undefined || vContext.userData.user_interest === null){
      fieldsList.push('user_interest')
    }
    if(vContext.userData.user_qualification === "" || vContext.userData.user_qualification === undefined || vContext.userData.user_qualification === null){
      fieldsList.push('user_qualification')
    }
    if(vContext.userData.user_specialisation === "" || vContext.userData.user_specialisation === undefined || vContext.userData.user_specialisation === null){
      fieldsList.push('user_specialisation')
    }
    //alert(vContext.userData.user_type_id);
    if((vContext.userData.user_mci_no === "" || vContext.userData.user_mci_no === undefined || vContext.userData.user_mci_no === null) && (vContext.userData.user_type_id !=5 && vContext.userData.user_type_id !=6 && vContext.userData.user_type_id !=8)){
     // alert("before");
      fieldsList.push('mci')
    }
    // console.log("fieldsList",fieldsList)
    let finalList = fieldsList.slice(0, 6);
    let fieldsCopy: any = fields;
    finalList.map((f:any)=>{
      fieldsCopy[f] = true;
    })
    // console.log('updated finall fields status', fieldsCopy)
    setFields(fieldsCopy)

    
  },[vContext.userData])
  return (
  <div className={styles.UpdateProfile}>
    <Modal
        show={show}
        // onHide={handleClose}
        // backdrop="static"
        keyboard={false}
      >
        <Modal.Header >
          <Modal.Title>Update Your Profile</Modal.Title>
        </Modal.Header>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Modal.Body>
          <p>
            Kindly Keep your profile updated so as to get relevent notifications for CMEs of you Interest
          </p>
         {/* Email */}
         {/* {(vContext.userData.user_email === '')&& */}
         {(fields.user_email)&&
            <Form.Group as={Col} controlId="email">
            <Form.Control required type="email" placeholder="Email" onChange={(e:any)=>{setEmail(e.target.value)}}/>
            <Form.Control.Feedback type="invalid"> Please provide a valid Email.</Form.Control.Feedback>
          </Form.Group>
          }
          {/* Phone Number */}
          {/* {(vContext.userData.user_phone_no === '')&& */}
          {(fields.user_phone_no)&&
            <Form.Group as={Col} controlId="phone">
            <PhoneInput placeholder="Enter phone number" required  value={phoneNo} defaultCountry="IN"
             onChange={(e:any)=>{ setPhoneNo(e); checkIsValid(e)}}/>
            {/* <Form.Control.Feedback type="invalid"> Please provide a valid Email.</Form.Control.Feedback> */}
            {invalidPhone && <div className="invalid-feedback" style={{display: 'block'}}>Please provide a valid number.</div>}
          </Form.Group>
          }  
           {/* Country */}
           {/* {(vContext.userData.user_country === '')&& */}
           {(fields.user_country)&&
            <Form.Group as={Col} controlId="country">
            <Form.Control as="select" required custom onChange={(e:any)=>{
              setCountry(e.target.value)
              if(vContext.userData.user_country === "India" && (vContext.userData.user_state === "" || vContext.userData.user_state === undefined || vContext.userData.user_state === null))
              {
              if(e.target.value == "India")
              {
                fields.user_state =false;
                fields.user_state_list =true;
              }
              else
              {
                fields.user_state_list =false;
                fields.user_state =true;
              }
            }
              }}>
              <option value={''}>Select Country</option>
              {countries.map((item:any)=>
              <option value={item.name}>{item.name}</option>
              )}
            </Form.Control>
            <Form.Control.Feedback type="invalid">Please provide a valid Country.</Form.Control.Feedback>
          </Form.Group>
          }
          {(fields.user_title)&&
            <Form.Group as={Col} controlId="usertitle">
            <Form.Control as="select" required custom onChange={(e:any)=>{
              setUserTitle(e.target.value);
             
              }}>
              <option value={''}>Select Title</option>
              
              <option value="Dr.">Dr.</option>
              <option value="Mr.">Mr.</option>
              <option value="Ms.">Ms.</option>
              
            </Form.Control>
            <Form.Control.Feedback type="invalid">Please select Title.</Form.Control.Feedback>
          </Form.Group>
          }
        {/* First Name */}
          {/* {(vContext.userData.user_first_name === '')&& */}
          {(fields.user_first_name)&&
           <Form.Group as={Col} controlId="firstname">
            <Form.Control required type="text" placeholder="First name" onChange={(e:any)=>{
              var  value = e.target.value;
              value = value.replace(/[^A-Za-z]/gi, "");
              value = value.charAt(0).toUpperCase() + value.slice(1);
              e.target.value = value;
              setFirstName(e.target.value)}}/>
            <Form.Control.Feedback type="invalid"> Please provide a valid first Name.</Form.Control.Feedback>
          </Form.Group>
          }
          {/* Last Name */}
          {/* {(vContext.userData.user_last_name === '')&& */}
          {(fields.user_last_name)&&
            <Form.Group as={Col} controlId="lastname">
            <Form.Control required type="text" placeholder="Last name" onChange={(e:any)=>{
              var  value = e.target.value;
              value = value.replace(/[^A-Za-z]/gi, "");
              value = value.charAt(0).toUpperCase() + value.slice(1);
              e.target.value = value;
              setLastName(e.target.value)}}/>
            <Form.Control.Feedback type="invalid"> Please provide a valid last Name.</Form.Control.Feedback>
          </Form.Group>
          }
           {/* User type Id */}
           {/* {(vContext.userData.user_country === '')&& */}
           {(fields.user_type_id)&&
            <Form.Group as={Col} controlId="usertypeid">
            <Form.Control as="select" required custom onChange={(e:any)=>{
              setUserTypeId(e.target.value);
              fields.user_hospital_name =true;
              if(e.target.value == "9")
              {
              fields.user_type =true;
              fields.hospital =false;
              fields.company =false;
              }
              else if(e.target.value == "7")
              {
              fields.hospital =true;
              fields.company =false;
              fields.user_type =false;
              fields.user_hospital_name =false;
              }
              else if(e.target.value == "5" || e.target.value == "6")
              {
              fields.company =true;
              fields.hospital =false;
              fields.user_type =false;
              fields.user_hospital_name =false;
              

              }
              else
              {
                fields.user_type =false;
                fields.hospital =false;
                fields.company =false;

              }
              if(e.target.value == "5" || e.target.value == "6" || e.target.value == "8")
              {
                fields.mci =false;
              }
              }}>
              <option value={''}>Select User Type</option>
              {user_type.map((item:any)=>
              <option value={item.user_type_id}>{item.name}</option>
              )}
            </Form.Control>
            <Form.Control.Feedback type="invalid">Please select user type.</Form.Control.Feedback>
          </Form.Group>
          }
          {/* User type */}
          {/* {(vContext.userData.user_last_name === '')&& */}
          {(fields.user_type)&&
            <Form.Group as={Col} controlId="usertype">
            <Form.Control required type="text" placeholder="User Type" onChange={(e:any)=>{setUserType(e.target.value)}}/>
            <Form.Control.Feedback type="invalid"> Please specify user type.</Form.Control.Feedback>
          </Form.Group>
          }

          {/* User type */}
          {/* {(vContext.userData.user_last_name === '')&& */}
          {(fields.hospital)&&
            <Form.Group as={Col} controlId="hospital">
            <Form.Control required type="text" placeholder="Hospital Name" onChange={(e:any)=>{
              setUserType(e.target.value)
              setHospital(e.target.value)
              }}/>
            <Form.Control.Feedback type="invalid"> Please enter hospital name.</Form.Control.Feedback>
          </Form.Group>
          }
          {/* User type */}
          {/* {(vContext.userData.user_last_name === '')&& */}
          {(fields.company)&&
            <Form.Group as={Col} controlId="company">
            <Form.Control required type="text" placeholder="Company Name" onChange={(e:any)=>{
              setUserType(e.target.value)
              setHospital(e.target.value)
            }}/>
            <Form.Control.Feedback type="invalid"> Please enter company name.</Form.Control.Feedback>
          </Form.Group>
          }
          {/* City */}
          {/* {(vContext.userData.user_city === '')&& */}
          {(fields.user_city)&&
          <Form.Group as={Col} controlId="city">
            <Form.Control type="text" placeholder="City" required onChange={(e:any)=>{
              var  value = e.target.value;
              value = value.replace(/[^A-Za-z -]/gi, "");
              value = value.charAt(0).toUpperCase() + value.slice(1);
              e.target.value = value;
              setCity(e.target.value)}}/>
            <Form.Control.Feedback type="invalid">Please provide a valid city.</Form.Control.Feedback>
          </Form.Group>
          }
           {(fields.user_hospital_name)&&
          <Form.Group as={Col} controlId="user_hospital_name">
            <Form.Control type="text" placeholder="Hospital name" required onChange={(e:any)=>{
              var  value = e.target.value;
              value = value.replace(/[^A-Za-z ',.-]/gi, "");
              value = value.charAt(0).toUpperCase() + value.slice(1);
              e.target.value = value;
              setHospital(e.target.value)}}/>
            <Form.Control.Feedback type="invalid">Please provide a hospital name.</Form.Control.Feedback>
          </Form.Group>
          }
          {/* State */}
          {/* {(vContext.userData.user_state)&& */}
          {(fields.user_state)&&
            <Form.Group as={Col} controlId="state">
            <Form.Control type="text" placeholder="State" required onChange={(e:any)=>{
               var  value = e.target.value;
               value = value.replace(/[^A-Za-z ]/gi, "");
               value = value.charAt(0).toUpperCase() + value.slice(1);
               e.target.value = value;
              setState(e.target.value)}}/>
            <Form.Control.Feedback type="invalid">Please provide a valid state.</Form.Control.Feedback>
          </Form.Group>
          }
          {(fields.user_state_list)&&
            <Form.Group as={Col} controlId="state">
            <Form.Control as="select" required custom onChange={(e:any)=>{
             
              setState(e.target.value)
              }}>
              <option value={''}>Select State</option>
              {state_list.map((item:any)=>
              <option value={item.name}>{item.name}</option>
              )}
            </Form.Control>
            <Form.Control.Feedback type="invalid">Please select state.</Form.Control.Feedback>
          </Form.Group>
          }
         
          {/* Interest */}
          {/* {(vContext.userData.user_interest === '')&& */}
          {(fields.user_interest)&&
            <Form.Group as={Col} controlId="interest" >
            <Form.Control as="select" custom  onChange={(e:any)=>{
               setInterest(e.target.value)
              }}>
              <option value={''}>Choose Interest</option>
              {vContext.userData.interestList.map((item:any)=>
              <option value={item.anatomy_id}>{item.anatomy_name}</option>
              )}
            </Form.Control>
            <Form.Control.Feedback type="invalid">Please provide a valid Interest.</Form.Control.Feedback>

          </Form.Group>
          }        
          {/* Qualification */}
          {/* {(vContext.userData.user_qualification === '')&& */}
          {(fields.user_qualification)&&
            <Form.Group as={Col} controlId="qualification">
            <Form.Control type="text" placeholder="Qualification" onChange={(e:any)=>{
              var  value = e.target.value;
              value = value.replace(/[^A-Za-z &',.-]/gi, "");
              value = value.charAt(0).toUpperCase() + value.slice(1);
              e.target.value = value;
              setQualification(e.target.value)}}/>
            <Form.Control.Feedback type="invalid"> Please provide a valid Qualification.</Form.Control.Feedback>
          </Form.Group>
          }
          {/* Specialisation */}
          {/* {(vContext.userData.user_specialisation === '')&& */}
          {(fields.user_specialisation)&&
            <Form.Group as={Col} controlId="specialisation">
            <Form.Control type="text" placeholder="Specialisation" onChange={(e:any)=>{
              var  value = e.target.value;
              value = value.replace(/[^A-Za-z &',.-]/gi, "");
              value = value.charAt(0).toUpperCase() + value.slice(1);
              e.target.value = value;
              setSpecialisation(e.target.value)}}/>
            <Form.Control.Feedback type="invalid">Please provide a valid Specialisation.</Form.Control.Feedback>
          </Form.Group>
          }  
          {(fields.mci)&&
            <Form.Group as={Col} controlId="mci">
            <Form.Control required type="text" placeholder="Medical Council Registration number" onChange={(e:any)=>{setMCI(e.target.value)}}/>
            <Form.Control.Feedback type="invalid">Please enter Medical Council Registration number.</Form.Control.Feedback>
          </Form.Group>
          }   
        </Modal.Body>
        <Modal.Footer>          
          <Button type="submit" variant="primary">Update</Button>
        </Modal.Footer>
        </Form>
      </Modal>
  </div>
)};

export default UpdateProfile;
